import { Helmet } from 'react-helmet-async'

export const About = () => {
  return (
    <div className='container my-10 mx-auto flex items-start bg-[#5E81AC] p-6 lg:h-auto text-white rounded-md'>
      <Helmet>
        <title> درباره ما</title>
        <meta
          name='description'
          content='بوک استوری - هر کتاب یک داستان، هر داستان یک زندگی دوباره'
        />
      </Helmet>
      <div className='w-full flex flex-col xl:flex-row items-center my-6'>
        <div className='xl:w-[25%]'>
          <img
            src='/assets/images/about.webp'
            alt='about image'
            className='w-full h-full lg:ml-4 rounded-md object-contain'
          />
        </div>
        <div className='flex flex-col items-start xl:w-[74%] mr-8'>
          <h1 className='text-4xl underline underline-offset-8 decoration-0 font-medium font-medium text-right my-6'>
            درباره بوک‌استوری
          </h1>
          <h4 className='text-2xl font-medium font-medium text-right my-0'>
            سلام دوست عزیز، به دنیای قشنگ بوک استوری خوش اومدی !📚✨
          </h4>
          <p className='text-lg font-medium font-medium text-right my-6 max-w-5xl'>
            ما تو بوک‌استوری یه رویای ساده و دل‌انگیز داریم: کتاب‌هایی که یه
            گوشه‌ی کتابخونه‌تون دارن خاک می‌خورن رو دوباره زنده کنیم و به دست
            آدمایی برسونیم که منتظرن تا با خوندنشون غرق داستان و دانش بشن.
            این‌جوری نه‌تنها لذت کتابخونی رو باهم شریک می‌شیم، بلکه یه قدم بزرگ
            برای سیاره‌مون برمی‌داریم. 🌍💚 <br />
            هر کتابی که به اشتراک می‌ذارید، یه فرصت تازه‌ست برای گسترش فرهنگ
            کتابخوانی، جلوگیری از قطع درخت‌ها و زنده نگه داشتن داستان‌ها. تو
            روزگاری که قیمت کتاب‌ها حسابی بالا رفته، ما اینجاییم تا با
            بازگردوندن کتاب‌ها به چرخه‌ی زندگی، هم به جیب‌تون کمک کنیم و هم کاری
            کنیم که همه بتونن با هزینه‌ی کمتر به دنیای کتاب‌ها سفر کنن. 📖😊
            <br />
            بیاید با هم کتاب‌ها رو از سکوت دربیاریم، به طبیعت یه نفس تازه بدیم و
            لبخند رو به آدمای بیشتری هدیه کنیم. اگه کتابی دارید که آماده‌ست یه
            ماجراجویی جدید رو شروع کنه، بهمون خبر بدید تا این داستان قشنگ رو
            باهم ادامه بدیم! 🚀 <br /> مرسی که همراه مایید و بخشی از قصه‌ی
            بوک‌استوری هستید! <br />
            <br />
            با کلی عشق،
            <br /> تیم بوک‌استوری ❤️
          </p>
        </div>
      </div>
    </div>
  )
}
